"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/utils/ownerDocument.js
// module id = 57
// module chunks = 0